// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-A":"A_dpu-detail-A__DRuzi","logo":"A_logo__FK0Pq","ef-box":"A_ef-box__ANp6q"};